import * as React from 'react';
import { observer } from 'mobx-react';

const styles = require('./EmptyState.scss');
const classNames = require('classnames/bind').bind(styles);

export interface EmptyStateProps {
    icon: string;
    mainMessage: string;
    detailMessage?: string;
    classNames?: {
        container?: string;
        mainMessage?: string;
    };
}

@observer
export default class EmptyState extends React.Component<EmptyStateProps, {}> {
    render() {
        const { icon, mainMessage, detailMessage } = this.props;

        const { container: containerClassName, mainMessage: mainMessageClassName } = this.props
            .classNames || { container: null, mainMessage: null };

        return (
            <div className={classNames(styles.emptyStateContainer, containerClassName)}>
                {icon && <img className={styles.icon} src={icon} />}
                {mainMessage && (
                    <span className={classNames(styles.mainMessageText, mainMessageClassName)}>
                        {mainMessage}
                    </span>
                )}
                {detailMessage && (
                    <span className={styles.detailsMessageText}>{detailMessage}</span>
                )}
            </div>
        );
    }
}
